import { Injectable } from '@angular/core';
import {ServerService} from "./ServerService";
import {BehaviorSubject} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AvaliacaoService extends ServerService {
  constructor(http: HttpClient) {
    super(http);
  }

  liste(inicio: number, total: number, filtros: any = {}) {
    return this.obtenha('/avaliacoes/liste', {...filtros, i: inicio, t: total})
  }

  obtenhaConfiguracaoPublicacao() {
    return this.obtenha('/avaliacoes/configuracao', {});
  }

  salveConfiguracaoPublicacao(notaMinima: number) {
    return this.facaPut('/avaliacoes/configuracao', {notaMinima: notaMinima});
  }

  // publicacao null = volta a seguir a regra.
  altereVisibilidade(avaliacao: any, publicacao: string) {
    return this.facaPut(`/avaliacoes/${avaliacao.id}/publicacao`, {publicacao: publicacao});
  }
}
